import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { useTranslation } from 'react-i18next';

ChartJS.register(ArcElement, Tooltip, Legend);

interface OrderTypeChartProps {
  totalOrders: number;
  totalShipForMe: number;
}

export const OrderTypeChart: React.FC<OrderTypeChartProps> = ({ totalOrders, totalShipForMe }) => {
  const { t } = useTranslation();

  // Check if we have any data
  const hasData = totalOrders > 0 || totalShipForMe > 0;

  const chartData = {
    labels: [
      t('menu.buy4meOrders'),
      t('menu.ship4meOrders'),
    ],
    datasets: [
      {
        label: t('common.orders'),
        data: [totalOrders, totalShipForMe],
        backgroundColor: [
          '#3b82f6',
          '#f59e0b',
        ],
        borderColor: [
          '#1d4ed8',
          '#d97706',
        ],
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            const total = totalOrders + totalShipForMe;
            const percentage = total > 0 ? ((context.parsed / total) * 100).toFixed(1) : '0';
            return context.label + ': ' + context.parsed + ' (' + percentage + '%)';
          }
        }
      }
    },
  };

  return (
    <div className="chart-container">
      <h3>{t('dashboard:orderTypes')}</h3>
      {hasData ? (
        <Doughnut data={chartData} options={options} />
      ) : (
        <div className="no-data-message">
          <p>{t('dashboard:noData')}</p>
        </div>
      )}
    </div>
  );
};

